import { render } from "./ActivePrj.vue?vue&type=template&id=1cb7982c&scoped=true"
import script from "./ActivePrj.vue?vue&type=script&lang=js"
export * from "./ActivePrj.vue?vue&type=script&lang=js"

import "./ActivePrj.vue?vue&type=style&index=0&id=1cb7982c&lang=css"
import "./ActivePrj.vue?vue&type=style&index=1&id=1cb7982c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb7982c"]])

export default __exports__